<template>
  <div>
    <h3>优惠券活动</h3>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item label="活动id">
        <el-input v-model.number="filter.id" placeholder="活动id"></el-input>
      </el-form-item>
      <el-form-item label="活动类型">
        <el-select v-model="filter.activityType">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(label, value) in map.coupon.activityType"
            :key="value"
            :label="label"
            :value="Number(value)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="活动时间">
        <el-date-picker
          v-model="filter.activityStartTime"
          type="date"
          placeholder="开始时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          :editable="false"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="filter.activityEndTime"
          type="date"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :editable="false"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
        <el-button
          type="primary"
          @click="$router.push('/coupon/activity')"
          size="mini"
          >新建</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="id" label="活动id"></el-table-column>
      <el-table-column prop="activityName" label="活动名称"></el-table-column>
      <el-table-column prop="type" label="活动类型">
        <template slot-scope="scope">{{
          map.coupon.activityType[scope.row.activityType]
        }}</template>
      </el-table-column>
      <el-table-column prop="type" label="优惠券类型">
        <template slot-scope="scope">{{
          map.coupon.type[scope.row.type]
        }}</template>
      </el-table-column>
      <el-table-column prop="" label="总发放额度">
        <template slot-scope="scope">{{
          scope.row.couponAmount * scope.row.couponNum
        }}</template>
      </el-table-column>
      <el-table-column prop="couponNum" label="总发放数量"></el-table-column>
      <el-table-column
        prop="thresholdAmount"
        label="门槛金额"
      ></el-table-column>
      <el-table-column prop="couponAmount" label="额度"></el-table-column>
      <el-table-column prop="" label="优惠券领取链接">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.needToExchange === 1"
            type="text"
            class="copy-btn"
            :data-clipboard-text="`${frontUrl}/coupon/exchange/${scope.row.aesId}`"
            @click="copy"
            >复制链接</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="activityStartTime"
        label="开始时间"
      ></el-table-column>
      <el-table-column
        prop="activityEndTime"
        label="结束时间"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="">
                <a :href="`/coupons?id=${scope.row.id}`" target="_blank"
                  >查看明细</a
                >
              </el-dropdown-item>
              <el-dropdown-item command="">
                <a :href="`/coupon/activity?id=${scope.row.id}`" target="_blank"
                  >编辑</a
                >
              </el-dropdown-item>
              <el-dropdown-item command="">
                <a :href="`/coupon/assign/${scope.row.id}`" target="_blank"
                  >指定用户发券</a
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";
import Clipboard from "clipboard";
const { coupon } = api;

export default {
  name: "couponActivities",
  data() {
    return {
      map,
      filter: {
        id: "",
        activityType: "",
        activityStartTime: "",
        activityEndTime: "",
      },
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      total: 0,
    };
  },
  components: {},
  computed: {},
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  methods: {
    copy() {
      var clipboard = new Clipboard(".copy-btn");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.error("复制失败，请手动复制收款地址");
        // 释放内存
        clipboard.destroy();
      });
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let { id, activityStartTime, activityEndTime, activityType } =
        this.filter;
      let obj = {
        pageNum: pageNum,
        limit: limit,
        id: Number.isInteger(id) ? id : "",
        activityStartTime,
        activityEndTime,
        activityType,
      };

      let res = await coupon.activities(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    handleCommand() {},
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/coupon/activities.vue